import React, { type ReactNode } from 'react';
import type { FieldType } from '../../../types/EvalancheTypes';
import { Container, Textarea, FormLabel, ErrorMessage } from '../styles';

export const TextareaInput = ({
  field,
  formikProps,
}: {
  field: FieldType;
  formikProps: any;
}): ReactNode => (
  <Container>
    <FormLabel tag="span" type="lead" className="text-gray-500">
      {field.label}
    </FormLabel>
    <Textarea
      value={formikProps.values[field.name]}
      name={field.name}
      onChange={formikProps.handleChange}
      hidden={field.hidden}
      readOnly={field.readonly}
      required={field.required}
      data-test={`textarea-${field.name}`}
    />
    {formikProps.errors[field.name] && (
      <ErrorMessage data-test={`textarea-${field.name}-error`}>
        {formikProps.errors[field.name]}
      </ErrorMessage>
    )}
  </Container>
);
